'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dUsername$0024$0024anon$002452 from "./presto.types$-Credential-Username$$anon$52.js";
import * as $j_presto$002etypes$0024$002dCredential$002dUsername$0024$0024anon$002453 from "./presto.types$-Credential-Username$$anon$53.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialUsername$() {
  this.c5N = null;
  this.c5O = false;
  this.c5R = null;
  this.c5S = false;
  this.c5P = null;
  this.c5Q = false;
  this.c5T = null;
  this.c5U = false;
}
export { $c_Lpresto_types$CredentialUsername$ as $c_Lpresto_types$CredentialUsername$ };
$p = $c_Lpresto_types$CredentialUsername$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialUsername$;
/** @constructor */
function $h_Lpresto_types$CredentialUsername$() {
}
export { $h_Lpresto_types$CredentialUsername$ as $h_Lpresto_types$CredentialUsername$ };
$h_Lpresto_types$CredentialUsername$.prototype = $p;
$p.gS = (function() {
  if ((!this.c5O)) {
    this.c5N = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c5O = true;
  }
  return this.c5N;
});
$p.ct6 = (function() {
  if ((!this.c5S)) {
    this.c5R = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c5S = true;
  }
  return this.c5R;
});
$p.cJu = (function() {
  if ((!this.c5Q)) {
    this.c5P = new $j_presto$002etypes$0024$002dCredential$002dUsername$0024$0024anon$002452.$c_Lpresto_types$CredentialUsername$$anon$52(this);
    this.c5Q = true;
  }
  return this.c5P;
});
$p.a3e = (function() {
  if ((!this.c5U)) {
    this.c5T = new $j_presto$002etypes$0024$002dCredential$002dUsername$0024$0024anon$002453.$c_Lpresto_types$CredentialUsername$$anon$53(this);
    this.c5U = true;
  }
  return this.c5T;
});
var $d_Lpresto_types$CredentialUsername$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialUsername$, "presto.types$CredentialUsername$", ({
  Ze: 1,
  D: 1
}));
export { $d_Lpresto_types$CredentialUsername$ as $d_Lpresto_types$CredentialUsername$ };
var $n_Lpresto_types$CredentialUsername$;
function $m_Lpresto_types$CredentialUsername$() {
  if ((!$n_Lpresto_types$CredentialUsername$)) {
    $n_Lpresto_types$CredentialUsername$ = new $c_Lpresto_types$CredentialUsername$();
  }
  return $n_Lpresto_types$CredentialUsername$;
}
export { $m_Lpresto_types$CredentialUsername$ as $m_Lpresto_types$CredentialUsername$ };
//# sourceMappingURL=presto.types$-Credential-Username$.js.map
